var path = 'app/portainer/components/sidebar/sidebar-section/sidebar-section.html';
var html = "<div class=\"sidebar-section\">\n  <li class=\"sidebar-title\">\n    <span>{{ ::$ctrl.title }}</span>\n  </li>\n\n  <div class=\"sidebar-section-items\" ng-transclude> </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;